import { ChevronLeftSmall } from 'ui/icons/navigation/ChevronLeftSmall';
import type { BreadcrumbProps, LinkContent, ButtonContent } from './types';
import { BreadcrumbContainer, StyledAnchor, StyledButton, StyledLink } from './Breadcrumb.styled';

export const Breadcrumb = ({ isAngularLink, isButton, breadcrumb, variant }: BreadcrumbProps) => {
  const breadcrumbAnchor = breadcrumb as LinkContent;
  const breadcrumbButton = breadcrumb as ButtonContent;

  if (!isButton)
    return (
      <BreadcrumbContainer>
        {isAngularLink ? (
          <StyledAnchor
            data-test="page-header-breadcrumb"
            href={breadcrumbAnchor.href}
            data-variant={variant}
            data-type="anchor"
          >
            <ChevronLeftSmall isColorInherited />
            {breadcrumbAnchor.content}
          </StyledAnchor>
        ) : (
          <StyledLink
            data-test="page-header-breadcrumb"
            to={breadcrumbAnchor.href}
            data-variant={variant}
            data-type="link"
          >
            <ChevronLeftSmall isColorInherited />
            {breadcrumbAnchor.content}
          </StyledLink>
        )}
      </BreadcrumbContainer>
    );

  return (
    <BreadcrumbContainer>
      <StyledButton
        data-test="page-header-breadcrumb"
        onClick={breadcrumbButton.onClick}
        data-variant={variant}
        data-type="button"
      >
        <ChevronLeftSmall isColorInherited />
        {breadcrumbButton.content}
      </StyledButton>
    </BreadcrumbContainer>
  );
};
